import api from './api';

export const whatsappService = {
  getConfig: async () => {
    const response = await api.get('/whatsapp/config');
    return response.data;
  },

  saveConfig: async (data) => {
    const response = await api.post('/whatsapp/config', data);
    return response.data;
  },

  getStatus: async () => {
    const response = await api.get('/whatsapp/status');
    return response.data;
  },

  generateQRCode: async () => {
    const response = await api.get('/whatsapp/qrcode');
    return response.data;
  },

  disconnect: async () => {
    const response = await api.post('/whatsapp/disconnect');
    return response.data;
  }
};
